import React, { Children, useContext, useEffect, useState } from "react";
import "./diagnosticoResultPdf.scss";
import ScoreBar from "../resultados/score-bar/scoreBar";
import ResultCard from "../../molecules/result-card/resultCard";
import authContext from "../../../shared/src/contexts/authContext";
import mujerDiagnostico from "../../../assets/mujer-diagnostico.png";
import logo from "../../../../src/shared/src/assets/logo.png";
import facebookIcon from "../../../assets/facebook-icon.svg";
import instagramIcon from "../../../assets/instagram-icon.svg";
import { normalizeText } from "../../../shared/src/utils/stringManipulation";

const DiagnosticoResultPdf = React.forwardRef<any, any>(
  (props: { results: any }, ref) => {
    const context = useContext(authContext);
    const { results } = props;

    const auth = useContext(authContext);
    const userName= normalizeText(auth.gigyaAccount?.profile.firstName + ' ' + auth.gigyaAccount?.profile.lastName as string) 


    const [fechaActual, setFechaActual] = useState('');

    useEffect(() => {
      const fecha = new Date();
  
      const dia = fecha.getDate().toString().padStart(2, '0');
      const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const año = fecha.getFullYear();
  
      const fechaFormateada = `${dia}/${mes}/${año}`;
  
      setFechaActual(fechaFormateada);
    }, []);
    
    return (
      <>
        <div className="diagnostico-result-pdf" ref={ref}>
          <header className="diagnostico-result-pdf__header">
            <div className="diagnostico-result-pdf__header__background"></div>
            <img src={logo} alt="Logo Mentoría Financiera" />
          </header>
          <div className="diagnostico-result-pdf__title">
            <h1>¡Hola <span>{userName}</span>!</h1>
            <h2>Tu indicador de salud y educación financiera nos dice que:</h2>
          </div>
          <section className="diagnostico-result-pdf__score">
            <div className="diagnostico-result-pdf__score__info">
              <img src={mujerDiagnostico} alt="Imagen Diagnostico Financiero" />
              <h1>{results.financialHealth.title}</h1>
              <p>{results.financialHealth.challengeDescription}</p>
            </div>
            <div className="mentoria-resultados-pdf__body__results-card">
              <div className="mentoria-resultados-pdf__body__results-card__content">
                <header className="mentoria-resultados-pdf__body__results-card__content__header">
                  <h2 className="mentoria-resultados-pdf__body__results-card__content__header__number">
                    {results?.totalScore || 0}
                  </h2>
                  <div className="mentoria-resultados-pdf__body__results-card__content__header__description">
                    <h4 className="mentoria-resultados-pdf__body__results-card__content__header__description__title">
                      Tu puntaje
                    </h4>
                    <p className="mentoria-resultados-pdf__body__results-card__content__header__description__subtitle">
                      Puntaje máximo 100
                    </p>
                  </div>
                </header>
                <div className="mentoria-resultados-pdf__body__results-card__content__body">
                  {results?.score?.map((score) => {
                    return (
                      <ScoreBar
                        key={score.name}
                        title={score.name}
                        color={score.color || "#1AA8A2"}
                        score={score.value}
                        toolTipHelp={score.description}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </section>
          <div className="background-color__pdf"></div>
          <div className="background-color__diagnostico"></div>
          <section className="diagnostico-result-pdf__indicators">
            <div className="diagnostico-result-pdf__indicators__title">
              <h1>Indicadores</h1>
              <h6>
                Este indicador se compone 4 variables que te mostrarán en donde
                tienes oportunidades de mejora.
              </h6>
            </div>
            <div className="diagnostico-result-pdf__indicators__cards">
              {results?.indicators &&
                results.indicators.map((indicator, idx) => {
                  let calculatedScore;

                  if (indicator.value < 50) {
                    calculatedScore = "bad";
                  } else if (indicator.value < 80) {
                    calculatedScore = "medium";
                  } else {
                    calculatedScore = "good";
                  }

                  return (
                    <ResultCard
                      title={indicator.name}
                      description={indicator.description}
                      score={calculatedScore}
                    ></ResultCard>
                  );
                })}
            </div>
            <div className="diagnostico-result-pdf__indicators__title-footer">
              <p>¡Recuerda programar tu mentoría!</p>
            </div>
          </section>
          <nav className="footer-nav-pdf">
            <div className="diagnostico-result-pdf__footer">
              <p>Resultado {fechaActual}</p>
              <a
                href="https://www.facebook.com/comfamaservifinancieros/"
                rel="noreferer"
                target="_blank"
              >
                <img src={facebookIcon} alt="Facebook Mentoria Financiera" />
                <p>/comfamaserviciosfinancieros</p>
              </a>
              <a
                href="https://www.instagram.com/comfamaserviciosfinancieros/"
                rel="noreferer"
                target="_blank"
              >
                <img src={instagramIcon} alt="Instagram Mentoria Financiera" />
                <p>@comfamaserviciosfinancieros</p>
              </a>
            </div>
          </nav>
        </div>
      </>
    );
  }
);

export default DiagnosticoResultPdf;
